var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticStyle:{"margin-right":"4px"},attrs:{"size":"small","icon":"edit","type":"primary","ghost":""},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }